<div class="loader-container">
    <app-loader
        [remainingAmount]="remainingAmount"
        [color]="color"
        [showNumber]="remainingTimeInSeconds > 0"
        [number]="remainingTimeInSeconds"
    ></app-loader>
</div>
